export default {
  formTitles: {
    create: 'Create Project',
    edit: 'Edit Project',
  },
  sections: {
    details: {
      title: 'Project Details',
      subtitle: '',
    },
    members: {
      title: 'Project Members',
      subtitle: '',
    },
  },
  subHeaders: {
    basicDetails: 'Basic details',
    image: 'Project image',
    inviteMembers: 'Invite project members',
  },
  fields: {
    projectName: 'Project name',
    projectOwner: 'Project owner',
    projectStatus: 'Project status',
    imageConstraint: 'JPG, PNG or Webp · max 10 MB',
    imageErrors: {
      size: 'That image is over 10 MB. Choose a smaller file.',
      type: 'Use a JPG, PNG or Webp image.',
      unreadable: 'Could not process that image. Try a different file.',
      cropInProgress: 'Confirm or cancel the crop before saving.',
    },
    member: {
      label: 'Project member',
      placeholder: 'Member',
    },
    role: {
      label: 'Project role',
      placeholder: 'Role',
    },
  },
  membersTable: {
    columns: {
      email: 'Email',
      role: 'Roles',
      action: 'Action',
    },
    empty: {
      title: 'No members added yet',
      description: 'Members you add to this project will appear here.',
    },
    invite: 'Invite',
    remove: 'Remove member',
    newUser: 'New user · an invite will be sent',
  },
};
